import React, { useMemo, useState } from "react";
import { sortBy } from "lodash";
import { CheckboxGroup, CheckboxGroupOption } from "../../../../components/checkboxGroup";
import { Dropdown } from "../../../../components/dropdown";
import { ReactComponent as NumericDescSortIcon } from "../../../../assets/icons/arrow-up-1-9-solid.svg";
import { ReactComponent as AlphabeticAscSortIcon } from "../../../../assets/icons/arrow-up-z-a-solid.svg";
import styles from "./mineTypeFilter.module.css";

export interface MineItem {
  mine: string;
  count: number;
}

export type Sort = "alphabetic" | "numeric";

interface MineTypeFilterProps {
  open?: boolean;
  value?: string[];
  options: MineItem[];
  onChange: (options: string[]) => void;
}

export const MineTypeFilter = ({ open, value, options, onChange }: MineTypeFilterProps) => {
  const [sort, setSort] = useState<Sort>("numeric");

  const changeSort = () => {
    setSort(sort === "alphabetic" ? "numeric" : "alphabetic");
  };

  const getMine = (key: string) => {
    return options.find((option) => option.mine === key);
  };

  const sortOptions = useMemo(() => {
    if (sort === "alphabetic") {
      return (options: CheckboxGroupOption[]) => sortBy(options, ["mine"]);
    } else {
      return (options: CheckboxGroupOption[]) => {
        return options.sort((a, b) => {
          const aMine = getMine(a.key);
          const bMine = getMine(b.key);

          return aMine === undefined || bMine === undefined ? 0 : bMine.count - aMine.count;
        });
      };
    }
  }, [sort, options]);

  return (
    <Dropdown
      title="Mine Type:"
      open={open}
      content={
        <CheckboxGroup
          checkAllLabel="All Mine Types"
          value={value || []}
          options={options.map((mine) => ({ key: mine.mine, label: mine.mine }))}
          onChange={onChange}
          renderOptionLabel={(option, el) => {
            const mineObj = getMine(option.key);

            return (
              <div className={styles.option}>
                {el}
                {mineObj ? <span title="Mines count">{mineObj.count}</span> : undefined}
              </div>
            );
          }}
          sortOptions={sortOptions}
          headerExtraLeft={
            <div onClick={changeSort} className={styles.sortBlock}>
              {sort === "alphabetic" ? (
                <AlphabeticAscSortIcon className={styles.sortIcon} />
              ) : (
                <NumericDescSortIcon className={styles.sortIcon} />
              )}
            </div>
          }
        />
      }
    />
  );
};
